const API_KEY_GETTERS = {
  formData: 'apiKey/formData',
  isLoading: 'apiKey/isLoading',
  sorting: 'apiKey/sorting',
  actionLoading: 'apiKey/actionLoading',
  items: 'apiKey/items',
  range: 'apiKey/range',
}

const API_KEY_DISPATCHERS = {
  resetStore: 'apiKey/resetStore',
  resetPage: 'apiKey/resetPage',
  getQueryParams: 'apiKey/getQueryParams',
  createApiKey: 'apiKey/createApiKey',
  updateApiKey: 'apiKey/updateApiKey',
  deleteApiKey: 'apiKey/deleteApiKey',
  getApiKeys: 'apiKey/getApiKeys',
  resetFiltersAndSorting: 'apiKey/resetFiltersAndSorting',
  onSelectSort: 'apiKey/onSelectSort',
  setRange: 'apiKey/setRange',
  changePage: 'apiKey/changePage',
}

export { API_KEY_GETTERS, API_KEY_DISPATCHERS }
